import React from 'react';
import {
  Box, Stack, Tooltip, Typography,
} from '@mui/material';
import { differenceInHours, differenceInDays } from 'date-fns';
import { OutlinedIcons } from '@marageti/z4-lib';

const { OutlinedClockIcon } = OutlinedIcons;

interface LastMessageTimestampChipProps {
  timestamp: string;
}

const LastMessageTimestampChip = ({ timestamp }: LastMessageTimestampChipProps) => {
  const now = new Date();
  const messageDate = new Date(timestamp);

  const hours = differenceInHours(now, messageDate);
  const days = differenceInDays(now, messageDate);

  const formattedTime = hours >= 24 ? `${days}d` : `${hours}h`;
  const chipColor = hours >= 24 ? 'error' : 'default';

  if (Number.isNaN(hours) || Number.isNaN(days)) {
    return null;
  }

  return (
    <Tooltip title={`Last message sent ${formattedTime} ago`}>
      <Box
        component="span"
        sx={(theme) => ({
          display: 'flex',
          width: '64px',
          padding: '2px 8px',
          justifyContent: 'center',
          alignItems: 'center',
          fontWeight: 'bold',
          height: '24px',
          backgroundColor: chipColor === 'error' ? theme.palette.error.light : theme.palette.grey[200],
          borderRadius: '16px',
        })}
      >
        <Stack direction="row" alignItems="center" gap="4px">
          <OutlinedClockIcon
            sx={{
              fontSize: 16,
              fontWeight: 'bold',
              color: (theme) => (chipColor === 'error' ? theme.palette.error.main : theme.palette.grey[500]),
            }}
          />
          <Typography variant="caption" sx={{ fontWeight: 'bold', color: 'text.primary' }}>
            {formattedTime}
          </Typography>
        </Stack>
      </Box>
    </Tooltip>
  );
};

export default LastMessageTimestampChip;
